import JSZip from 'jszip';

const downloadFile = async (url, filename = null) => {
  const response = await fetch(url);
  const data = await response.blob();
  return { filename: filename || url.substring(url.lastIndexOf('/') + 1).split('?')[0], data };
};

// Main function to download files and create ZIP
export const downloadAndCompressFiles = async (filesInfo, archiveName) => {
  const zip = new JSZip();
  const files = await Promise.all(filesInfo.map(info => downloadFile(info.url, info.filename)));
  files.forEach(file => {
    zip.file(file.filename, file.data);
  });

  const content = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
  const zipFilename = archiveName || 'mybespokeroom.zip';
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(content);
  downloadLink.download = zipFilename;
  downloadLink.click();
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/ziped_files_downloader.js